import PropTypes from 'prop-types';
import React from 'react';
import FunctionalTestTarget from 'components/FunctionalTestTarget';
import FunctionalTestIds from 'constants/FunctionalTestIds';
import Icon from 'components/Icon';
import InputWithIcon from 'components/InputWithIcon';
import {connect} from 'react-redux';
import {search, reset} from 'state/people/peopleSearchActions';
import {
  selectSearchQuery,
  selectSearchResults,
} from 'state/people/peopleSearchSelectors';
import {selectAllUserIds} from 'state/user/userSelectors';
import {loadAllUsers} from 'state/user/userActions';
import {injectIntl, defineMessages} from 'react-intl';
import ScrollPager from 'components/ScrollPager';
import UserList from 'components/UserList';

const messages = defineMessages({
  search: {
    id: 'PeopleList__SearchPeople',
    defaultMessage: 'Search people',
    description: 'Input placeholder for searching all people.',
  },
});

class PeopleList extends React.Component {
  componentDidMount() {
    if (this.props.allUserIds.length === 0) {
      this.props.loadAllUsers();
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }

  handleScrollBottom = () => {
    this.props.loadAllUsers();
  };

  handleSearchChange = value => {
    this.props.search(value);
    if (this.props.onSearch) this.props.onSearch();
  };

  render() {
    const {
      query,
      results,
      allUserIds,
      onAccountClick,
      intl,
      selected,
    } = this.props;
    const isSearch = query && results;
    const userIds = isSearch ? results.map(user => user.id) : allUserIds;

    return (
      <ScrollPager onScrollBottom={this.handleScrollBottom}>
        <div>
          <FunctionalTestTarget id={FunctionalTestIds.PEOPLE__SEARCH_INPUT}>
            <InputWithIcon
              onInputChange={this.handleSearchChange}
              icon={<Icon icon={Icon.OPTIONS.SEARCH} />}
              placeholder={intl.formatMessage(messages.search)}
            />
          </FunctionalTestTarget>
          <UserList
            isSearch={isSearch}
            userIds={userIds}
            selected={selected}
            onClick={onAccountClick}
          />
        </div>
      </ScrollPager>
    );
  }
}

PeopleList.propTypes = {
  onAccountClick: PropTypes.func.isRequired,
  selected: PropTypes.object,
  onSearch: PropTypes.func,
};

PeopleList.defaultProps = {
  selected: new Set(),
};

export default injectIntl(
  connect(
    state => ({
      query: selectSearchQuery(state),
      results: selectSearchResults(state),
      allUserIds: selectAllUserIds(state),
    }),
    {
      search,
      reset,
      loadAllUsers,
    }
  )(PeopleList)
);
